<template>
  <nav class="related" :class='size'>
    <template v-for='row in pages' :key='row.page[0]'>

      <template v-if='isFeatured(row)'>
        <FeaturedBookRow
          v-if="pageFromUid(row.page[0])?.pagetype === 'book'"
          :uid="row.page[0]"
          :intro='row.intro || ""'
        />
        <FeaturedEventRow
          v-else-if="pageFromUid(row.page[0])"
          :uid='row.page[0]'
          :intro='row.intro || ""'
        />
      </template>

      <!-- Compact row -->
      <a :href="'/' + row.page[0]" v-else-if='pageFromUid(row.page[0])'>
        <h3 class='caret' v-html="pageFromUid(row.page[0]).title" />
        <h3 v-html="pageFromUid(row.page[0]).appendix" />
      </a>

    </template>
  </nav>
</template>

<script setup>
  import { computed } from 'vue'
  import { useStore } from '../KQL.js'
  import { pageFromPath } from '../helpers.js'
  import FeaturedBookRow from './FeaturedBookRow.vue'
  import FeaturedEventRow from './FeaturedEventRow.vue'

  const kql = useStore();
  const props = defineProps(['pages', 'size']);

  // Reactive lookup — subcomponents also do their own reactive lookup
  const pageFromUid = (uid) => uid ? pageFromPath(uid, kql.pages) : null;
  const isFeatured = row => row.featured == true || row.featured === 'true';
</script>

<style scoped>
@import '../css/breakpoints.css';

  h3 {
    padding-left: 0.75em;
    line-height: 1.1em;
    margin: 0;
    position: relative;
  }

  h3.caret::before {
    position: absolute;
    left: 0;
    content: '›';
    transition: transform 0.1s ease-in-out;
  }

  h3:not(.caret) {
    text-align: right;
  }

  @media (--phone) {
    h3 {
      line-height: 1.2em;
      font-size: 2.25rem;
    }
  }

  a:hover h3.caret::before {
    transform: translateX(0.1em);
  }

  nav.related {
    margin: 0;
    padding: 0;
    padding-bottom: 0.3em;
    border-bottom: 1px solid var(--border);
    margin-bottom: 3rem;
  }

  .Large { font-size: 1.6rem; }
  nav.Small { font-size: 1.15rem; }

  nav.Large:deep(h3) { letter-spacing: -0.018em; }
  nav.Small:deep(h3) { letter-spacing: -0.01em; }

  nav.related:deep(> a:not(.event-row)) {
    line-height: 1.2em;
    box-sizing: border-box;
    border-top: 1px solid var(--border);
    margin: 0;
    display: flex;
    justify-content: space-between;
    padding-top: 1rem;
    padding-bottom: 1.5rem;
    color: inherit;
    text-decoration: none;
  }
</style>
